<template>
  <div class="teaching-page">
    <nav class="breadcrumb">
      <router-link class="breadcrumb__link" to="/">{{ breadcrumb.home }}</router-link>
      <span class="breadcrumb__separator">/</span>
      <span class="breadcrumb__current">{{ breadcrumb.current }}</span>
    </nav>

    <!-- <header class="teaching-page__intro">
      <h1>{{ intro.title }}</h1>
      <p v-if="intro.description">{{ intro.description }}</p>
    </header> -->

    <section
      v-for="institution in institutions"
      :key="institution.id || institution.title"
      class="teaching-section"
    >
      <h2 class="teaching-section__heading">
        <span>{{ institution.title }}</span>
        <span v-if="institution.subtitle" class="teaching-section__subtitle">
          {{ institution.subtitle }}
        </span>
      </h2>

      <ul class="course-list">
        <li v-for="course in institution.courses" :key="course.id || course.code">
          <div class="course-line">
            <span class="course-code" v-if="course.code">{{ course.code }}</span>
            <span v-if="course.code" class="course-separator">:</span>
            <span class="course-title">{{ course.name }}</span>
            <span v-if="course.note" class="course-note">{{ course.note }}</span>
          </div>
          <ul v-if="course.terms?.length" class="course-terms">
            <li v-for="term in course.terms" :key="term">{{ term }}</li>
          </ul>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import { getLocaleBlock } from '@/utils/i18n';

export default {
  name: 'TeachingView',
  computed: {
    page() {
      return getLocaleBlock(this.$i18n, 'teachingPage', {}) || {};
    },
    breadcrumb() {
      const crumb = this.page.breadcrumb || {};
      return {
        home: crumb.home || 'Home',
        current: crumb.current || 'Teaching',
      };
    },
    intro() {
      const intro = this.page.intro || {};
      return {
        title: intro.title || 'Teaching',
        description: intro.description || '',
      };
    },
    institutions() {
      const list = this.page.institutions;
      return Array.isArray(list) ? list : [];
    },
  },
};
</script>

<style scoped>
.teaching-page {
  max-width: 960px;    
  margin-right: auto;
  margin-left: auto;
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 0.95rem;
  color: #5a6783;
}

.breadcrumb__link {
  color: inherit;
  text-decoration: none;
}

.breadcrumb__link:hover {
  color: #1f4cff;
}

.breadcrumb__separator {
  color: #a3afc7;
}

.breadcrumb__current {
  color: #1f3150;
  font-weight: 600;
}

.teaching-page__intro h1 {
  margin: 0;
  font-size: 2rem;
  color: #172742;
}

.teaching-page__intro p {
  margin: 0.8rem 0 0;
  max-width: 720px;
  color: #4c5f82;
  line-height: 1.6;
}

.teaching-section {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}

.teaching-section__heading {
  margin: 0;
  font-size: 1.5rem;
  color: #1b2f4f;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.teaching-section__subtitle {
  font-size: 1rem;
  font-weight: 500;
  color: #5a6b8b;
}

.course-list {
  list-style: disc;
  margin: 0;
  padding-left: 1.4rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  color: #2a3d5f;
}

.course-list > li {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.course-line {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  align-items: baseline;
  font-size: 1.02rem;
}

.course-code {
  font-weight: 600;
  color: #1d2f52;
}

.course-separator {
  color: #1d2f52;
  font-weight: 600;
}

.course-title {
  font-weight: 500;
}

.course-note {
  font-style: italic;
  color: #617299;
}

.course-terms {
  list-style: circle;
  margin: 0;
  padding-left: 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  color: #51658a;
  font-size: 0.95rem;
}

@media (max-width: 640px) {
  .teaching-page {
    gap: 2rem;
  }

  .teaching-page__intro h1 {
    font-size: 1.8rem;
  }

  .teaching-section__heading {
    font-size: 1.35rem;
  }
}
</style>
